import {MenuItemAggregate} from '../../../../../aggregats/menu/menu-item.aggregate';
import {EparcoursPath} from '../../eparcours-path';

export const accueilMenuItem: MenuItemAggregate = new MenuItemAggregate(
  'icon-home1',
  'Accueil',
  undefined,
  `/${EparcoursPath.root.ACCUEIL}`,
);
